import React from "react";
import { graphql } from "gatsby";
import { ButtonBar as ButtonBarComponent } from "@zempler/theme/src/components/buttonbar/ButtonBar";
import { ButtonComponentRenderer } from "../../ButtonComponentRenderer";

export const ButtonBar = ({ data, ...rest }) => (
  <ButtonBarComponent {...data}>
    {data.buttons.map((button, index) => (
      <ButtonComponentRenderer components={[button.component]} key={index} />
    ))}
  </ButtonBarComponent>
);

export const ButtonBarQuery = graphql`
  fragment ButtonBar on UMBRACO_ButtonBarComponentType {
    centered
    buttons {
      component {
        ...ButtonComponents
      }
    }
  }
`;
